<template>
  <section class="main-content is-transparent">
    <div class="hero">
      <h1
        class="subtitle is-2 is-subtle is-uppercase has-text-primary mb-0 pb-0 has-text-weight-bold"
      >
        {{ $t("register.header") }}
      </h1>
      <div class="description is-2 mb-5 is-subtle has-text-weight-normal">
        <p>{{ $t("register.description") }}</p>
      </div>

      <div class="grid">
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
          <form class="form" @submit.prevent="handleSubmit(authRegister)">
            <div class="spinner-container" v-if="isLoadingData">
              <b-loading
                class="spinner-loader"
                :is-full-page="false"
                v-model="isLoadingData"
              />
            </div>
            <ValidationProvider
              rules="required|min:2|max:50"
              v-slot="{ errors }"
              class="form__element"
            >
              <b-field
                :message="errors[0]"
                class="is-custom-field"
                :label="$t('register.form.firstName.label')"
              >
                <b-input
                  :disabled="isLoadingData"
                  type="text"
                  class="is-custom-input"
                  :placeholder="$t('register.form.firstName.placeholder')"
                  v-model="userinput.fname"
                />
              </b-field>
            </ValidationProvider>
            <ValidationProvider
              rules="required|min:2|max:50"
              v-slot="{ errors }"
              class="form__element"
            >
              <b-field
                :message="errors[0]"
                class="is-custom-field"
                :label="$t('register.form.lastName.label')"
              >
                <b-input
                  :disabled="isLoadingData"
                  type="text"
                  class="is-custom-input"
                  :placeholder="$t('register.form.lastName.placeholder')"
                  v-model="userinput.lname"
                />
              </b-field>
            </ValidationProvider>
            <ValidationProvider
              rules="required|min:5|max:50"
              v-slot="{ errors }"
              class="form__element"
            >
              <b-field
                :message="errors[0]"
                class="is-custom-field"
                :label="$t('register.form.email.label')"
              >
                <b-input
                  :disabled="isLoadingData"
                  type="email"
                  class="is-custom-input"
                  :placeholder="$t('register.form.email.placeholder')"
                  v-model="userinput.email"
                />
              </b-field>
            </ValidationProvider>
            <ValidationProvider
              rules="required|min:8|max:24|password"
              v-slot="{ errors }"
              class="form__element"
            >
              <b-field
                :message="errors[0]"
                class="is-custom-field"
                :label="$t('register.form.password.label')"
              >
                <b-input
                  :disabled="isLoadingData"
                  type="password"
                  autocomplete="new-password"
                  class="is-custom-input"
                  :placeholder="$t('register.form.password.placeholder')"
                  v-model="userinput.password"
                />
              </b-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|min:8|max:24|confirmed:${userinput.password}|password`"
              v-slot="{ errors }"
              class="form__element"
            >
              <b-field
                :message="errors[0]"
                class="is-custom-field"
                :label="$t('register.form.passwordConfirm.label')"
              >
                <b-input
                  :disabled="isLoadingData"
                  type="password"
                  autocomplete="new-password"
                  class="is-custom-input"
                  :placeholder="$t('register.form.passwordConfirm.placeholder')"
                  v-model="userinput.passwordConfirm"
                />
              </b-field>
            </ValidationProvider>
            <div
              v-if="responseError"
              class="notification is-danger has-text-weight-bold"
            >
              {{ responseError }}
            </div>
            <div class="field is-grouped">
              <div class="control">
                <button
                  :disabled="invalid || isLoadingData"
                  class="button is-primary"
                  type="submit"
                >
                  {{ $t("register.form.submit") }}
                </button>
                <!-- <button
                                    class="button is-link"
                                    @click="authLogout()"
                                >
                                    Logout
                                </button> -->
              </div>
              <!-- <div class="control">
                                <button class="button is-link is-light">
                                    Cancel
                                </button>
                            </div> -->
            </div>
          </form>
        </ValidationObserver>
        <div class="grid">
          <div class="form-card mt-3 login-actions">
            <span
              class="is-size-5 has-text-weight-bold mx-1 mb-2 is-primary-alt"
            >
              {{ $t("register.loginquestion") }}</span
            >
            <button
              class="button is-primary-alt is-size-6 has-text-weight-bold mx-1"
              @click="$router.push(localePath('/u/login'))"
            >
              {{ $t("register.login") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
          

<style lang="scss" scoped>
.notification {
  border-radius: 16px;
}
.spinner-loader {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  // z-index: 10;
  // pointer-events: none;
}
.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--bg-secondary);
  z-index: 1000000000;
  display: flex;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
}
.login-actions {
  /* text-align: center; */

  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 2rem;
  font-size: 1.125rem;

  .action-link {
    color: var(--primary);
    font-weight: 600;
    text-decoration: none;
    margin: 0 0.5rem;
    &:hover {
      text-decoration: underline;
    }
  }
}

.form-card {
  width: 100%;
  max-width: 400px;
  min-width: 400px;
  margin: 0 auto;
  padding: 2rem;
  position: relative;
  border-radius: var(--radius-sm);
  overflow: hidden;
  background: var(--bg-secondary);
  @media (max-width: 500px) {
    width: 90vw;
    height: 100%;
    min-width: 90vw;
  }
}
.form {
  width: 100%;
  max-width: 400px;
  min-width: 400px;
  margin: 0 auto;
  padding: 2rem;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  background: var(--bg-secondary);
  box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.1);
  @media (max-width: 500px) {
    width: 90vw;
    height: 100%;
    min-width: 90vw;
    // border-radius: 0;
    box-shadow: none;
  }
}
.parsed-paragraph {
  white-space: pre-line;
}

.is-custom-field {
  margin-bottom: 2rem;
}
.is-custom-input {
  background: var(--bg);
}

.is-fullheight {
  // margin-top: 5rem;
  // height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.hero {
  margin: 2rem 0;
  max-width: 500px;
  @media (max-width: 500px) {
    max-width: 90vw;
  }
}
.hero-content {
  // width: 100%;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hero-body {
  @media (min-width: 960px) {
    max-width: 850px;
  }
}
.image-lightbox {
  position: relative;
  background: var(--bg-secondary);
  width: 100%;
  // height: 60vh;
  padding: 2em 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 960px) {
    padding: 0;
  }
}

.event-image {
  object-fit: contain;
  max-width: 750px;
  overflow: hidden;
  border-radius: 0.5em;
  @media (max-width: 960px) {
    width: 100%;
    border-radius: 0;
  }
}

.header {
  // min-height: 5rem;
  // width: 100%;
  // margin-top: 1rem;
  display: flex;
  flex-direction: column;
  height: auto;
  // margin: 0.5em 1em;
  // flex-wrap: nowrap;
  justify-content: flex-start;
  .title-span {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

.flexstart-icon {
  width: auto !important;
}

.is-event-label {
  width: 24px;
  min-width: 24px;
  min-height: 24px;
  max-height: 100%;
  // display: flex;
  // flex-direction: row;
  // margin: 0;
  padding: 0;
  border-radius: 5em;
  margin-right: 0.5em;
}

.link-box {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.hero-qrcode {
  animation: appear 0.5s ease-in-out;
  width: 100%;
  height: 100%;
  // min-height: 300px
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .qrcode-canvas {
    overflow: hidden;
    border-radius: 1rem;
    // border: 1px solid red;
  }
}

.result-box {
  /* width: 100%; */
  /* height: 100%; */
  margin-top: 1rem;
  width: calc(100vw - 2rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: var(--bg-secondary);
  padding: 2rem;
  border-radius: var(--radius-xs);
}
.result_field {
  font-size: 1.25rem;
  font-weight: 500 !important;
  color: var(--color-success);
  /* margin-bottom: 0.35rem; */
}
.result > .result_field {
  text-align: center;
  font-weight: 300;
}
.result {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25rem;
}
</style>

<script>
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { email, max, min, oneOf, required } from "vee-validate/dist/rules";
import { apiBaseName } from "~/utils/gql";

extend("required", {
  ...required,
  message: "Campo richiesto",
});

extend("min", {
  ...min,
  message: "Minimo caratteri: {length}",
});
extend("password", {
  validate: (value) => {
    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,24})"
    );

    return strongRegex.test(value);
  },
  message:
    "La password deve contenere 8-24 caratteri, di cui una lettera maiuscola, e un numero",
});
extend("max", {
  ...max,
  message: "Massimo caratteri: {length}",
});
extend("confirmed", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Le password non coincidono",
});

extend("email", {
  ...email,
  message: "Indirizzo e-mail non valido.",
});

extend("oneOf", {
  ...oneOf,
  message: "Paese non valido",
});
export default {
  name: "PublicSignup",

  data() {
    return {
      pageTitle: "TDF*P — " + this.$t("register.meta.title"),
      isLoadingData: false,
      tesserati: [],
      password: "",
      email: "",
      userinput: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        passwordConfirm: "",
      },
      responseError: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  watch: {
    $route(to, from) {
      this.$store.commit("setCurrPageTitle", this.$t("register.header"));
    },
  },
  beforeMount() {
    // this.$store.commit("setCurrPageTitle", this.$t("register.header"));
  },
  mounted() {
    this.$store.commit("setCurrPageTitle", this.$t("register.header"));

    this.enterAnimation();
  },
  layout: "default",

  head() {
    return {
      title: this.pageTitle,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      // console.log(from);
    });
  },
  methods: {
    async authRegister() {
      this.responseError = "";
      this.isLoadingData = true;
      try {
        const res = await this.$axios
          .$post(`${apiBaseName}/api/signup`, {
            headers: {
              "Content-Type": "application/json",
            },
            mailHeaders: {
              "X-MT-Category": "user-registration",
            },
            email: this.userinput.email,
            firstName: this.userinput.fname,
            lastName: this.userinput.lname,
            password: this.userinput.password,
          })
          .catch((err) => {
            // console.log(err);
            // console.log(res);

            this.responseError = this.$t("form.errors.invalid");
            this.isLoadingData = false;
          });
        // console.log("RES", res);
        if (res && res.errors && res.errors.length > 0) {
          if (res.errors[0].message.startsWith("E11000")) {
            this.responseError = this.$t("form.errors.already_registered");
          } else if (res.errors[0].message.startsWith("E999")) {
            this.responseError = this.$t("form.errors.mail_failure");
          } else if (res.errors[0].message.startsWith("E998")) {
            this.responseError = this.$t("form.errors.generic");
          } else {
            this.responseError = res.errors[0].message;
          }
          this.isLoadingData = false;
        } else if (res && res === "OK") {
          this.isLoadingData = false;
          this.$router.push(this.localePath("/u/confirm/success"));
        } else {
          this.responseError = this.$t("form.errors.generic");
          this.isLoadingData = false;
        }
      } catch (e) {
        console.error(e);
        console.log(e);
      }
    },
    // async asyncData() {

    //     // console.log(this.$router.currentRoute);
    //     return this.loadedEvent;
    // },
    enterAnimation() {
      const anime = this.$anime;
      anime({
        targets: ".main-content",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        filter: ["blur(2rem)", "blur(0px)"],
        duration: 360,
      });
    },
  },
  setup(props, { emit }) {
    const form = props.userinput;

    const submitForm = () => {
      emit("submit", {
        form,
        onComplete: () => {},
        // TODO: Handle Error
        onError: () => {},
      });
    };

    return {
      form,
      submitForm,
    };
  },
};
</script>

